<template>
<form id="renameDatasetForm" method="post" @submit.prevent="customRenameDataset">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Rename Script Result: <span id="renameDatasetOriginalNameSpan">{{passedModalData}}</span></h5>
            <button type="button" class="btn-close" @click="$emit('closeModal')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="small mb-1" for="inputDataset">New Script Result Name</label>
              <input type="hidden" name="directory" id="directory" :value="passedModalData">
              <input @keydown.space="(event) => event.preventDefault()" class="form-control py-4" name="newname" id="newname" value=""
                placeholder="New Script Name" />
              <div class="form-text">Spaces have been disabled, please use an underscore or dash between words.</div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
            <button type="submit" class="btn btn-primary">Rename</button>
          </div>
        </div>
      </form>
</template>
<script>
import axios from 'axios';
export default {
  name: 'ModalRenameScriptForm',
  props: {
    passedModalData: ''
  },
  methods : {
    customRenameDataset() {
        let formData = new FormData();
        formData.append('directory', this.passedModalData);
        formData.append('newname', document.getElementById('newname').value);
          axios.post('/rename_a_script', formData)
          .then(
            (response) => {
                console.log('response from script rename '+JSON.stringify(response.data));
              this.$emit('messageAlert', {alert: 'Renaming Custom Script Directory', classel: 'info'});
              this.$emit('closeModal');
              this.$emit('customChange', {shell: 'ScriptsResults', dataset: ''});
            }
          )
          .catch(
            (error) => {
              this.errorMessage = error.message;
              console.error("There was an error!", error);
              }
          )
      }
  }
}
</script>